import { Container, Row, Col, Button, Form, Fade } from "react-bootstrap";
import { faMoneyBillAlt as fasMoneyBillAlt } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useLang } from "../../common/hooks/useLang";

export default function TransferButton(props) {

  const [showAnalysisInputError, setShowAnalysisInputError] = useState(false);

  useEffect(() => {
    if (props.analysisSelected === false) {
      // This is a hack: 
      // react-bootstrap transitions are not working as expected
      setTimeout(() => setShowAnalysisInputError(true), 200);
    } else {
      setShowAnalysisInputError(false);
    }
  }, [props.analysisSelected]);

  const { currentLanguage } = useLang();
  const { t } = useTranslation(NAMESPACE_REMOTE);

  if (props.standardOrderId === null) {
    return null;
  } else {
    return (
      <Container fluid="md" className="pt-3">
        <Row>
          <Col xs={12} xl={9}>
            <Form.Group className="mb-2">
              <Form.Label>
                <Form.Check inline={true} className="me-2" type="checkbox" required={true}
                            checked={props.termsAccepted} onChange={(e) => props.handleTermsAcceptedChanged(e)} />
                {t("TEXT.WSHOP2.CREATE_ORDER.CONFIRM_DOCUMENTS")}&nbsp;
              </Form.Label>
              <a href={currentLanguage === "en" ? `${window.AGB_URL_EN}` : `${window.AGB_URL_DE}`}
                 target="_blank" rel="noopener noreferrer">{t("TEXT.WSHOP2.CREATE_ORDER.TERMS_AND_CONDITIONS")}</a>
              <Form.Text>,&nbsp;</Form.Text>
              <a href={currentLanguage === "en" ? `${window.DSGVO_URL_EN}` : `${window.DSGVO_URL_DE}`}
                 target="_blank" rel="noopener noreferrer">{t("TEXT.WSHOP2.CREATE_ORDER.PRIVACY_POLICY")}</a>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={9}>
            <Form.Group className="text-muted fs-80 text-decoration-underline">
              {t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_ORDER_HINT")}
            </Form.Group>
            <Form.Group className="mb-2 text-muted fs-80 text-justify">
              {t("TEXT.WSHOP2.CREATE_ORDER.ORDER_HINT")}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={9}>
            <Form.Group className="text-muted fs-80 text-decoration-underline">
              {t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_DANGEROUS_GOODS_HINT")}
            </Form.Group>
            <Form.Group className="mb-2 text-muted fs-80 text-justify">
              {t("TEXT.WSHOP2.CREATE_ORDER.DANGEROUS_GOODS_HINT")}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={9}>
            <Form.Group className="mb-2 text-muted fs-80">
              {t("TEXT.WSHOP2.CREATE_ORDER.REQUIRED_FIELDS_HINT")}
            </Form.Group>
          </Col>
        </Row>
        {!props.analysisSelected && (
          <Row>
            <Col xs={12} xl={9}>
              <Form.Group className="mb-2">
                <Fade in={showAnalysisInputError}>
                  <p className="text-danger fw-bold">{t("TEXT.WSHOP2.CREATE_ORDER.NO_ANALYSIS_ERROR")}</p>
                </Fade>
              </Form.Group>
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={12} sm={6} lg={4} xl={3}>
            <Button
              variant="primary"
              type="submit"
              className="text-white mt-2 me-2 w-100"
            >
              <FontAwesomeIcon icon={fasMoneyBillAlt} className="me-2" />
              {t("PROMPT.WSHOP2.CREATE_ORDER.ORDER_FOR_A_FEE")}
            </Button>
          </Col>
          <Col xs={12} sm={6} lg={4} xl={3}>
            <Button
              variant="primary"
              className="text-white mt-2 me-2 w-100"
              onClick={(e) => props.handleCancelOrderClicked(e)}
            >
              <FontAwesomeIcon icon={faTimes} className="me-2" />
              {t("PROMPT.WSHOP2.CREATE_ORDER.ORDER_CANCEL")}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}
